import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

/*
import 'bootstrap/dist/css/bootstrap.css' // add
import 'bootstrap-vue/dist/bootstrap-vue.css' // add
*/
Vue.config.productionTip = false

import VuejsDialog from 'vuejs-dialog';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
Vue.use(VuejsDialog);

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
